import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Modal, Image, Button } from 'react-bootstrap';
import { handleGetPrintAddon_list } from './orderModel';
import { getImageUrl } from '../../../../MIS/Global';
import "./ClothPriceStep.css";

const PrintAddon = ({ printAddons, setPrintAddons, quote }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  useEffect(() => {
    if (printAddons?.length <= 0) {
      handleGetPrintAddon_list({ setLoading, setPrintAddons, quote });
    }
  }, []);

  const handleImageClick = (imgUrl) => {
    setModalImage(getImageUrl(`${imgUrl}`));
    setShowModal(true);
  };
  const handleCardClick = (id) => {
    const updatedAddons = printAddons.map((addon) => {
      if (addon.id === id) {
        const currentValue = addon?.addon_is ?? false;
        return {
          ...addon,
          addon_is: !currentValue,
        };
      }
      return { ...addon };
    });
  
    setPrintAddons(updatedAddons);
  };
  return (
    <div>    
      {loading ? (
        <div className="text-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        printAddons.map((item) => {
          const checked = item?.addon_is;
          return (
            <Card
              key={item.id}
              className="mb-2"
              style={{ cursor: 'pointer', userSelect: 'none' }}
              tabIndex={0}
              role="checkbox"
              aria-checked={checked}
              onClick={() => handleCardClick(item.id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleCardClick(item.id);
                }
              }}
            >
              <Card.Body className="py-2 px-3">
                <Row className="align-items-center">
                  <Col xs={1} className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={checked}
                      readOnly
                      tabIndex={-1}
                      id={`addon-checkbox-${item.id}`}
                    />
                  </Col>
                  <Col xs={7}>
                    <Form.Label
                      htmlFor={`addon-checkbox-${item.id}`}
                      className="mb-0 fw-semibold"
                      style={{ cursor: 'pointer' }}
                    >
                      {item?.print_addon_name}
                    </Form.Label>
                  </Col>
                  <Col xs={4} className="text-end">
                    {item?.imgpath && (
                      <Image
                        src={getImageUrl(`${item?.imgpath}`)}
                        alt={item.print_addon_name}
                        thumbnail
                        style={{ maxHeight: '50px', objectFit: 'cover', cursor: 'pointer' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImageClick(item.imgpath);
                        }}
                      />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          );
        })
      )}

      {/* Image Modal */}      
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Button
          variant="light"
          onClick={() => setShowModal(false)}
          className="modal-close-btn"
        >
          &times;
        </Button>
        <Modal.Body className="p-0 text-center modal-image-body">
          <Image src={modalImage} className="modal-image" />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PrintAddon;
